import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { QSAReport } from 'src/modules/serasa/serasa.experian.business.types'

export type ControleSocietarioProps = {
    controleSocietario?: QSAReport
}

export default function ControleSocietario({ controleSocietario }: ControleSocietarioProps) {
    return (
        <>
            <Divider textAlign="center">Controle Societário</Divider>
            {controleSocietario && controleSocietario.companyData && (
                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    <GridItem label="Origem" value={controleSocietario.companyData.countryOrigin || '-'} xs={6} />
                    <GridItem label="Controle" value={controleSocietario.companyData.controlType || '-'} xs={6} />
                    <GridItem label="Natureza" value={controleSocietario.companyData.nature || '-'} xs={6} />
                    <GridItem
                        label="Data Atualização"
                        value={
                            controleSocietario.companyData.informationUpdateDate
                                ? formatDate(controleSocietario.companyData.informationUpdateDate, 'dd/MM/yyyy')
                                : '-'
                        }
                        xs={6}
                    />
                </Grid>
            )}
        </>
    )
}
